import React from "react";
import { Flex, Typography } from "antd";
export const DropDownTitle = ({ label, value }) => (React.createElement(Flex, { vertical: true, gap: 3 },
    React.createElement(Typography.Text, { style: { fontSize: "12px", color: "white" } }, label),
    React.createElement(Typography.Text, { style: { minHeight: "22px", height: "22px", fontSize: "16px", color: "white" } }, value)));
